
import { Component, OnInit, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { PermissionDialogComponent } from 'path-shared/components/permission-dialog/permission-dialog.component';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { Builder } from 'path-shared/models/builder';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { NotificationService } from 'path-shared/services/notification/notification.service';
import { TramosTiposFilter } from '../models/tramos-tipos-filter';
import { TramosTiposTableComponent } from '../components/tramos-tipos-table/tramos-tipos-table.component';
import { TramosTiposFilterComponent } from '../components/tramos-tipos-filter/tramos-tipos-filter.component';
import { TramosTiposEditorComponent } from '../components/tramos-tipos-editor/tramos-tipos-editor.component';
@Component({
  selector: 'app-tramos-tipos',
  templateUrl: './tramos-tipos.component.html',
  styleUrls: ['./tramos-tipos.component.scss']
})
export class TramosTiposComponent implements OnInit {

  permissionDialogRef: MatDialogRef<PermissionDialogComponent>;
  activeFilters: string[] = [];
  filterData: TramosTiposFilter;
  somIdFoo: number;
  dataDialog: ComponentDialog = Builder.newComponentDialog();

  @ViewChild(TramosTiposTableComponent) tramosTiposTable: TramosTiposTableComponent;
  constructor(
    private dialog: MatDialog,
    public auth: AuthorizationService,
    private i18n: I18n,
    private not: NotificationService,
    public thisDialogRef: MatDialogRef<TramosTiposComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
  ) {
    this.filterData = new TramosTiposFilter('id', 'desc');
    if (data !== undefined) {
      this.dataDialog = data;
    }
  }

 

  ngOnInit() {
    this.auth.UserCanSeePage(this.auth.Pages.TipusVehicles);
    this.tramosTiposTable.itemClicked.subscribe(secure_id => {
      this.update(secure_id);
    });
    this.tramosTiposTable.itemSelected.subscribe(codi => {
      this.thisDialogRef.close(codi);
    });
  }

  ngAfterViewInit() {
    if (!this.dataDialog.isDialog) {
      this.not.titleChange(this.i18n('Tipus trams'));
    }
  }

  edit() {
    const idSeleccionat: string = this.tramosTiposTable.displayedItems['checkedItems'][0];
    this.update(idSeleccionat);
  }

  create() {
    this.update(null);
  }

  update(secure_id: string) {
    const data: ComponentDialog = Builder.newComponentDialog(true, false, secure_id);

    const ref = this.dialog.open(TramosTiposEditorComponent, {
      width: '70%',
      closeOnNavigation: false,
      autoFocus: true,
      data: data
    });

    ref.afterClosed().subscribe(updated => {
      if (updated) { this.tramosTiposTable.load(); }
    });
  }

  refresh() {
    this.tramosTiposTable.load();
  }

  onFilterClicked() {
    const ref = this.dialog.open(TramosTiposFilterComponent, {
      width: '50%',
      closeOnNavigation: false,
      autoFocus: true,
      data: {
        'filter': this.tramosTiposTable.filter
      }
    });

    ref.componentInstance.notify.subscribe((filter: TramosTiposFilter) => {
      this.tramosTiposTable.filter.set(filter);
      this.tramosTiposTable.load();
    });
  }

  onRowSelected(somid) {
    this.update(somid);
  }

  generateExcel() {
    this.tramosTiposTable.generateExcel();
  }

}
